import { useTheme } from '../../hooks/useTheme';

function ThemeAwareLogo({ lightSrc, darkSrc, alt = '', className }) {
  const { isDark } = useTheme();
  return (
    <img
      className={className}
      alt={alt}
      src={isDark ? darkSrc : lightSrc}
    />
  );
}

export default ThemeAwareLogo;
